import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, filter, map } from 'rxjs';
import { AppConfigService } from '@dexio/common';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  private readonly projectsSubject: Subject<Array<any>> = new Subject<Array<any>>();
  private projects: Array<any> = [];

  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }

  getProjects(): Observable<any> {
    this.retrieveProjects();
    return this.projectsSubject;
  }
  private retrieveProjects() {
    this.http
      .get(`${this.configs.get().apiUrl}/projects?includeClosed=true`)
      .subscribe({
        next: (_: any) => {
          this.projects = _;
          this.projectsSubject.next(_);
        }
      });
  }
  
  getProjectRoles() {
    return this.http
      .get(`${this.configs.get().apiUrl}/projects/roles`);
  }
  getStatistics(projectId: string) {
    return this.http
      .get(`${this.configs.get().apiUrl}/projects/${projectId}/stats`);
  }
  getUserStatistics(projectId: string) {
    return this.http
      .get(`${this.configs.get().apiUrl}/users/me/stats/projects/${projectId}`);
  }
  getPermissions(projectId: string): Observable<Array<any>> {
    return this.projectsSubject
      .pipe(filter((_: any) => _.id == projectId))
      .pipe(map((_: any) => _[0].userRoles));
  }
}
